import { MyPayeeSchema, type MyPayee } from '@youkuai/contracts';

import { apiRequest } from './project-api.ts';

export async function getOwnPayee(token: string): Promise<MyPayee> {
  return MyPayeeSchema.parse(await apiRequest('/me/payee', token));
}
